import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EventNoteService extends BaseService {
  private subject: Subject<void> = new Subject();
  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/notes`);
  }
  sendAddNoteClickedEvent() {
    this.subject.next();
  }
  getAddNoteClickedEvent(): Observable<void> {
    return this.subject.asObservable();
  }

  update(noteId: string, body: any, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${noteId}`;
    return this.http.put<any>(url, body, { params: this.toHttpParams(apiParams) });
  }

  delete(noteId: string, urlParams: any, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + `/${noteId}`;
    return this.http.delete<any>(url, { params: this.toHttpParams(apiParams) });
  }
}
